
const sortBy = function (arr, params) {
    return arr.sort(function (a, b) {
        if (a[params] > b[params]) { return -1 }
        if (a[params] < b[params]) { return 1 }
        return 0;
    });
};


export function Sum(arr) {
    return arr.map(function (a) { return a.scale }).reduce(function (a, b) { return a + b }, 0);
}


export function divide(arr, w, h, l, t) {
    let result= [];
    processDevide(arr, w, h, l, t);

    function processDevide(arr, w, h, l, t) {
        let _s_a = Sum(fairDivide(arr)[0]) / Sum(arr);
        let _v_a = { l: l, t: t, w: w > h ? Math.round(_s_a * w) : w, h: w > h ? h : Math.round(_s_a * h) };
        let _v_b = { l: w > h ? l + _v_a.w : l, t: w > h ? t : t + _v_a.h, w: w > h ? w - _v_a.w : w, h: w > h ? h : h - _v_a.h };
        let _a = fairDivide(arr)[0];
        let _b = fairDivide(arr)[1];
        if (_a.length > 1) {
            processDevide(_a, _v_a.w, _v_a.h, _v_a.l, _v_a.t);
        }
        if (_b.length > 1) {
            processDevide(_b, _v_b.w, _v_b.h, _v_b.l, _v_b.t);
        }
        if (_a.length === 1) {
            _a[0].position = _v_a;
            result.push(_a[0]);
        }
        if (_b.length === 1) {
            _b[0].position = _v_b;
            result.push(_b[0]);
        }
        if (!_b.length) return;
    }

    return result;
    
}



export function fairDivide(arr) {
    let a= [];
    let b= arr.slice();
    b = b.filter(i => i.scale > 0); //Removes Zero's
    let ratio = 0;
    sortBy(b,'scale');
    while (b.length > 0) {
        a.push(b[0]);
        b.splice(0, 1);
        if ((Math.min(Sum(a), Sum(b)) / Math.max(Sum(a), Sum(b))) < ratio) {
            b.unshift(a.pop());
            return ([a, b]);
        }
        ratio = Math.min(Sum(a), Sum(b)) / Math.max(Sum(a), Sum(b));
    }
    return ([a, b]);
}

